import { Pipe, PipeTransform } from '@angular/core';

/**
 * Filters a list of facet values by the hide property,
 * returning those where hide is not true.
 */
@Pipe({
  name: 'facetHideFilter',
  pure: true,
})
export class FacetHideFilterPipe implements PipeTransform {
  transform(items: any[]): any[] {
    return items.filter((item) => !item.hide);
  }
}
